/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Search_PlaceholderInputs */

const vi_meeting_guest_search_placeholder = /** @type {(inputs: Meeting_Guest_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ tên khách để tìm hoặc thêm mới…`)
};

/**

* @param {Meeting_Guest_Search_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_search_placeholder = /** @type {((inputs?: Meeting_Guest_Search_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Search_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_search_placeholder(inputs)
});